import { z } from "zod";

// Pagination Stats Schemas
export const AdminReviewsStatsSchema = z.object({
    total_pending: z.number(),
    total_published: z.number(),
    total_unpublished: z.number(),
});

export const ExpertReviewsStatsSchema = z.object({
    total_published: z.number(),
    average_rating: z.number(), // Overall average
    average_quality: z.number(), // Setup & Ease of Use
    average_communication: z.number(), // Features & Functionality
    average_timelines: z.number(), // Support Quality
    average_value_for_money: z.number(), // Value for Money
});

export const RatingBreakdownSchema = z.object({
    "5": z.number().int().nonnegative(),
    "4": z.number().int().nonnegative(),
    "3": z.number().int().nonnegative(),
    "2": z.number().int().nonnegative(),
    "1": z.number().int().nonnegative(),
});

export type RatingBreakdown = z.infer<typeof RatingBreakdownSchema>;

export const PublicReviewsStatsSchema = z.object({
    total_reviews: z.number(),
    average_rating: z.number(),
    rating_breakdown: RatingBreakdownSchema,
});
